import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';

class Leaderboard extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    listView(list = []) {
        return list.map((item, index) => {
            const url = formatUrl(item.url);

            return (
                <li key={index}>
                    <a className={styles.mr17} href={url} target="_blank" rel={relText}>
                        {index + 1}/
                    </a>
                    <a href={url} title={item.title} target="_blank" rel={relText}>
                        {item.title}/
                    </a>
                </li>
            );
        });
    }
    render() {
        const { content } = this.props;

        return [
            <div key="title" className={styles.bigTitleBox}>
                <h4 className={styles.bigTitle}>七天点击排行</h4>
                <span className={styles.lengLeft} />
                <span className={styles.lengRight} />
            </div>,
            <ul key="list" className={styles.list}>
                {this.listView(content)}
            </ul>,
        ];
    }
}

export default Leaderboard;
